import {
  Component,
  ElementRef,
  input,
  ViewChild,
  effect,
  InputSignal,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Chart, ChartData, ChartOptions, ChartType, Plugin } from 'chart.js';

@Component({
  selector: 'gc-chart',
  standalone: true,
  templateUrl: './chart.component.html',
  imports: [],
  styleUrls: ['./chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartComponent implements OnDestroy {
  options: InputSignal<ChartOptions | undefined> = input<ChartOptions>();
  data: InputSignal<ChartData | undefined> = input<ChartData>();
  type: InputSignal<ChartType | undefined> = input<ChartType>();
  plugins: InputSignal<Plugin[] | undefined> = input<Plugin[]>();
  @ViewChild('canvas', { static: true }) canvas!: ElementRef<HTMLCanvasElement>;

  private chartInstance!: Chart;

  constructor() {
    // todo redraw chart if container do resizing
    effect(() => {
      const type: ChartType | undefined = this.type();
      const data: ChartData | undefined = this.data();
      const options: ChartOptions | undefined = this.options();
      const plugins: Plugin[] | undefined = this.plugins();

      if (type && data && options && this.canvas && !this.chartInstance) {
        this.buildChart(type, data, options, plugins);
      }
    });

    // Combined effect for data and options updates to prevent animation interruption
    effect(() => {
      const data: ChartData | undefined = this.data();
      const options: ChartOptions | undefined = this.options();

      if (this.chartInstance && (data || options)) {
        if (data) this.chartInstance.data = data;
        if (options) this.chartInstance.options = options;
        this.updateChart();
      }
    });
  }

  private buildChart(type: ChartType, data: ChartData, options: ChartOptions, plugins?: Plugin[]): void {
    if (this.chartInstance) {
      this.destroyChart();
    }

    this.chartInstance = new Chart(this.canvas.nativeElement, {
      type,
      data,
      options,
      plugins: plugins || [],
    });
  }

  private updateChart(): void {
    if (this.chartInstance) {
      this.chartInstance.update('default');
    }
  }

  private destroyChart(): void {
    this.chartInstance?.destroy(); // optional chaining operator("?") needs in case of destroying, but it has not been initialized yet
  }

  ngOnDestroy(): void {
    this.destroyChart();
  }
}
